<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2026-->

<div class="modal-header">
  <h3 class="modal-title">Disclosure &amp; Feedback Loop</h3>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="hasAnyPrompts">
  <p class="text-muted m-b-md">
    Growth accelerates when awareness is shared. These disclosure statements are designed
    for honest dialogue with people in your inner and outer circles. Each one begins with
    <em>&ldquo;Something I'm learning about myself…&rdquo;</em> and ends with a practical
    request for feedback or support.
  </p>

  <ol class="m-b-none">
    <li *ngFor="let aud of audiences" class="m-b-md" [hidden]="!promptFor(aud.key)">
      <h5 class="font-bold m-b-xs">
        {{ aud.label }}
        <span class="text-muted">— {{ aud.vulnerability }}</span>
      </h5>
      <p class="m-b-none">{{ promptFor(aud.key) }}</p>
    </li>
  </ol>
</div>

<div class="modal-body" *ngIf="!hasAnyPrompts">
  <p class="text-muted text-center m-t-md m-b-md">
    No disclosure prompts available for this archetype.
  </p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="close()">Close</button>
</div>
